// extracted by mini-css-extract-plugin
module.exports = {"TableTitle":"TableTitle_TableTitle__1oa53"};